import { useState, useEffect } from 'react';
import { NAV_LINKS } from '../data/content';
import './Navbar.css';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__logo">
        <div className="navbar__icon">
          <svg width="20" height="20" viewBox="0 0 32 32" fill="none">
            <circle cx="16" cy="16" r="14" stroke="#1DD9C5" strokeWidth="2"/>
            <path d="M10 22 L16 10 L22 22" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 18h8" stroke="#1DD9C5" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
        <div>
          <div className="navbar__brand">Ai<span>va</span></div>
          <div className="navbar__sub">Domain-Specific AI Agents</div>
        </div>
      </div>

      <ul className={`navbar__links ${open ? 'navbar__links--open' : ''}`}>
        {NAV_LINKS.map(l => (
          <li key={l.href}>
            <a href={l.href} onClick={() => setOpen(false)}>{l.label}</a>
          </li>
        ))}
      </ul>

      <a href="#contact" className="navbar__cta btn-primary" onClick={() => setOpen(false)}>
        Talk to us
      </a>

      <button
        className={`navbar__burger ${open ? 'open' : ''}`}
        onClick={() => setOpen(!open)}
        aria-label="Toggle menu"
      >
        <span /><span /><span />
      </button>
    </nav>
  );
}
